/* This file contains the user preferences which can be sourced from the API at later point */

export const PAGINATION_LIMIT = 10;
export const REPORTS_ROWS_PER_PAGE = 50;
export const TABLE_NAMES = Object.freeze({
  APPS_TABLE: 'appsTable',
  CONTACTS_TABLE: 'contactsTable',
  REPORTING_TABLE: 'reportingTable'
});
export const DEFAULT_PREFERENCES = {
  resultsPerPage: {
    [TABLE_NAMES.APPS_TABLE]: PAGINATION_LIMIT,
    [TABLE_NAMES.CONTACTS_TABLE]: PAGINATION_LIMIT,
    [TABLE_NAMES.REPORTING_TABLE]: PAGINATION_LIMIT
  }
};